import { Link } from "react-router-dom";
import PageHeader from "@/components/marketing/PageHeader";
import { IMG } from "@/data/content";
import content from "@/data/specialtyUpdates.json";

export default function SpecialtyPage() {
  return <div data-testid="specialty-page">
    <PageHeader overline="Services" crumb="Industrial & Specialty" title={content.title} image={IMG.industrialSpecialty} />
    <section className="bg-rc-bg py-16 lg:py-24"><div className="max-w-7xl mx-auto px-5 lg:px-8">
      <p className="max-w-4xl text-lg text-rc-brown leading-relaxed mb-12">{content.intro}</p>
      <div className="grid lg:grid-cols-2 gap-8 items-start">{content.cards.map(({ title, subtitle, description, bullets, image }) => <article key={title} className="overflow-hidden rounded-2xl border border-black/10 bg-white">
        {image && <img src={image} alt={title} className="aspect-[16/9] w-full object-cover" loading="lazy" />}
        <div className="p-6 sm:p-8">
          <h2 className="font-heading text-2xl sm:text-3xl font-black text-rc-blue">{title}</h2>
          <p className="mt-3 font-semibold text-rc-charcoal leading-relaxed">{subtitle}</p>
          <p className="mt-5 text-rc-brown leading-relaxed">{description}</p>
          <ul className="mt-6 space-y-4 text-rc-brown leading-relaxed">{bullets.map(bullet => {
            const split = bullet.indexOf(":");
            return <li key={bullet} className="border-l-2 border-rc-red pl-4"><strong className="text-rc-charcoal">{bullet.slice(0, split + 1)}</strong>{bullet.slice(split + 1)}</li>;
          })}</ul>
        </div>
      </article>)}</div>
      <Link to="/contact/request-a-bid" className="inline-flex mt-12 rounded-full bg-rc-red text-white px-6 py-3 font-bold">Contact Specialty Divisions</Link>
    </div></section>
  </div>;
}
